import React from 'react';

function AllStarRankings() {
  return (
    <div>
      <h1>All-Star Rankings</h1>
      <div>
        <p>Welcome to the All-Star Rankings page. Rankings will be displayed here.</p>
      </div>
    </div>
  );
}

export default AllStarRankings;
